module.exports = __webpack_public_path__ + "static/img/default_photo.d7f1c549.png";